import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditOptionTypeDetailsComponent } from 'app/modules/option-type/component/edit-option-type-details/edit-option-type-details.component';
import { AddOptionTypeDetailsComponent } from 'app/modules/option-type/component/add-option-type-details/add-option-type-details.component';
import { ActivatedRoute } from '@angular/router';
import { DeleteDialogComponent } from 'app/core/shared/component/delete-dialog/delete-dialog.component';
import { OptionTypeService } from 'app/modules/option-type/services/option-type.service';
import module from 'app/modules/option-type/option-type.module';

@Component({
  selector: 'app-option-type-details',
  templateUrl: './option-type-details.page.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./option-type-details.page.scss']
})
export class OptionTypeDetailsPage {
  optionDetails$ = this.metadataService.optionDetails$

  optionId: string = ''
  titleDetails: string = '';
  optionItems: any = []

  public filterData = {
    pageNumber: 1,
    pageSize: 10,
    wellName: '',
    reportType: '',
    startDate: null,// new Date(),
    endDate: null
  }

  constructor(
    private elementRef: ElementRef,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private metadataService: OptionTypeService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.optionId = params['optionId']
      // this.titleDetails = params['categoryName']; // Access the value of a specific query parameter
      // this.optionItems= JSON.parse(params['detailsData'])
    });

    this.getOptionTypeDetails()
  }

  getOptionTypeDetails() {
    this.metadataService.getOptionsbyId(this.optionId).subscribe((res) => {
      this.titleDetails = res.name
      this.optionItems = res.optionItem
    })
  }

  nextPage() {
    this.filterData.pageNumber = this.filterData.pageNumber + 1
  }

  previousPage() {
    this.filterData.pageNumber = this.filterData.pageNumber - 1
  }

  updateDetailsModal(detailData: any) {
    const dialogRef = this.dialog.open(EditOptionTypeDetailsComponent, {
      data: detailData, // Pass your parameters here
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getOptionTypeDetails()
      }
    });
  }

  addOptionTypeDetails() {
    const dialogRef = this.dialog.open(AddOptionTypeDetailsComponent, {
      data: this.optionId, // Pass your parameters here
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getOptionTypeDetails()
    });
  }

  deleteOptionItem(id: any): void {
    const dialogRef = this.dialog.open(DeleteDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.metadataService.deleteOptionItem(id).subscribe((res) => {
          this.getOptionTypeDetails()
        })
      }
    });
  }

}
